export default __webpack_public_path__ + "static/06-296329048cac6b69acf72150559308b8.jpg";